import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "w-100 border-bottom p-3 d-flex flex-row align-items-center" };
const _hoisted_2 = {
    class: "small fw-bold text-white bg-secondary d-flex justify-content-center align-items-center",
    style: { "height": "30px", "width": "30px", "border-radius": "3px" }
};
const _hoisted_3 = { class: "ms-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.index + 1), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.page.title), 1)
    ]));
}
